// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".upload-outer-frame{border:1px solid var(--primaryLight);border-radius:10px}.upload-outer-frame .upload-inner-frame{border:1px dashed var(--primaryLight)}.upload-input{display:none}.upload-label{cursor:pointer}.upload-image{width:250px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
